import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.3_@babel+core@7.29.0_@playwright+test@1.61.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["HotlistHeader"] */ "/app/src/components/hotlist-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotlistTabs"] */ "/app/src/components/hotlist-tabs.tsx");
